
import PropTypes from 'prop-types'
import React from 'react'
import './index.css'
import Loader from 'ui/Loader'
import Alert from 'ui/Alert'
import Space from 'ui/Space'
import Block from 'ui/Block'
import Link from 'ui/Link'
import Button from 'ui/Button'
import BulletList from 'ui/BulletList'
import { FlexGrid, FlexItem } from 'ui/flexgrid'
import Code from 'ui/Code'
import ShowHide from 'ui/ShowHide'
import Tile from '../warehouse-setup-finish-tile'

const WarehouseSetupFinish = props => (
  <FlexGrid justifyContent='center'>
    <FlexItem width='700' spaceRight={24}>
      <div className='WarehouseSetupFinish'>
        <Alert type='success' title='We’ve connected and started loading your data'>
          Your data will be finished loading and ready to use within 24 hours. We’ll send you an email when the sync has finished.
        </Alert>
        <Space value='28' />
        <div className='WarehouseMetadataSelector'>
          <Block spaceTop={56} spaceLeft={56} spaceRight={56} spaceBottom={28}>
            <h1>How to use your Warehouse</h1>
            <Space value='14' />
            <p>
              You’ll need to connect to your database using a third-party tool. Here are a few tools you can use to connect your database to start querying data.
            </p>
            <Space value='28' />
            <Loader isLoading={props.isRequestingBITools} padding='100'>
              <ShowHide show={props.didFailToRequestBITools}>
                <Alert type='warning'>
                  An error occured trying to load partner BI tools. Please try again later.
                </Alert>
              </ShowHide>
              <ShowHide show={!props.didFailToRequestBITools}>
                <ul className='WarehouseSetupFinish-tiles'>
                  {props.bitools.map((bitool, index) =>
                    <Tile bitool={bitool} key={index} />
                  )}
                </ul>
              </ShowHide>
            </Loader>
            <Space value='28' />
            <p>
              You’ll use a third-party app to connect to your database and run queries. Here’s what a query might look like:
            </p>
            <Space value='14' />
            <Code>
              select * from source_name.event_name
            </Code>
            <Space value='28' />
            <h2>Further Reading</h2>
            <Space value='14' />
            <BulletList>
              <li>
                <Link href='https://segment.com/docs/warehouses/'target='_blank'>
                  Documentation
                </Link>
              </li>
              <li>
                <Link href='https://segment.com/docs/warehouses/schema/' target='_blank'>
                  Schema Reference
                </Link>
              </li>
              <li>
                <Link href='https://segment.com/docs/faqs/#warehouses' target='_blank'>
                  Warehouse FAQ
                </Link>
              </li>
            </BulletList>
          </Block>
          <div className='WarehouseMetadataSelector-submit'>
            <FlexGrid justifyContent='flex-end'>
              <FlexItem>
                <Button onClick={props.onFinishClick}>Finish Setup</Button>
              </FlexItem>
            </FlexGrid>
          </div>
        </div>
      </div>
    </FlexItem>
  </FlexGrid>
)

WarehouseSetupFinish.displayName = 'WarehouseSetupFinish'

WarehouseSetupFinish.propTypes = {
  bitools: PropTypes.array.isRequired,
  didFailToRequestBITools: PropTypes.bool.isRequired,
  isRequestingBITools: PropTypes.bool.isRequired,
  onFinishClick: PropTypes.func.isRequired
}

export default WarehouseSetupFinish



// WEBPACK FOOTER //
// ./pages/workspace-warehouses/components/warehouse-setup-finish/index.js